import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link 
              to="/"
              className="text-2xl font-bold text-blue-600 hover:text-blue-700 transition-colors cursor-pointer"
            >
              LegalClarityAI
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            <Link to="/how-it-works" className="text-gray-600 hover:text-blue-600 transition-colors">
              How It Works
            </Link>
            <Link to="/faq" className="text-gray-600 hover:text-blue-600 transition-colors">
              FAQ
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header; 